import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-grid p-m-0" }
const _hoisted_2 = { class: "p-col-12 " }
const _hoisted_3 = { class: "p-d-flex" }
const _hoisted_4 = { class: "p-float-label kn-flex p-mr-2" }
const _hoisted_5 = {
  class: "kn-material-input-label",
  for: "label"
}
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  class: "kn-material-input-label",
  for: "label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_t = _resolveDirective("t")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary dataPreparationSaveDialog",
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('workspace.myData.editPreparedDataset')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        label: _ctx.$t('common.cancel'),
        onClick: _ctx.cancel
      }, null, 8, ["label", "onClick"]),
      _withDirectives(_createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.apply,
        disabled: _ctx.saveButtonDisabled
      }, null, 8, ["onClick", "disabled"]), [
        [_directive_t, 'common.apply']
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", _hoisted_4, [
              _createVNode(_component_InputText, {
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.newDataset.name.$invalid
                            }],
                type: "text",
                modelValue: _ctx.v$.newDataset.name.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.newDataset.name.$model = $event)),
                modelModifiers: { trim: true },
                maxLength: "100"
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.dataset.name')), 1),
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.v$.newDataset.name,
                additionalTranslateParams: {
                                fieldName: _ctx.$t('managers.configurationManagement.headers.name')
                            }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ])
          ]),
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_Textarea, {
              class: ["kn-material-input p-mb-1", {
                            'p-invalid': _ctx.v$.newDataset.description.$invalid
                        }],
              type: "text",
              modelValue: _ctx.v$.newDataset.description.$model,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.newDataset.description.$model = $event)),
              modelModifiers: { trim: true },
              rows: "3",
              maxLength: "10000"
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.dataset.description')), 1),
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.newDataset.description,
              additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.configurationManagement.headers.description')
                        }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}